import { l } from './imports'

interface IIJ {
  i: number
  j: number
}

interface IXY {
  x: number
  y: number
}

export const distanceSquaredIJ = (a: IIJ, b: IIJ) => {
  let dx = a.i - b.i
  let dy = a.j - b.j
  return dx * dx + dy * dy
}
export const distanceSimpleIJ = (a: IIJ, b: IIJ) => {
  let dx = a.i - b.i
  let dy = a.j - b.j
  return Math.abs(dx) + Math.abs(dy)
}

export const isNextToIJ = (a: IIJ, b: IIJ) => {
  // if (node.k !== end.k) {
  //   return false
  // }
  let dx = Math.abs(a.i - b.i)
  let dy = Math.abs(a.j - b.j)
  if (dx + dy > 1) {
    return false
  }
  return true
}

export const distanceSquared = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
) => {
  let dx = x1 - x2
  let dy = y1 - y2
  return dx * dx + dy * dy
}

export const isAtIJ = (a: IIJ, b: IIJ) => {
  return a.i == b.i && a.j === b.j
}

export const isAt = (x1: number, y1: number, x2: number, y2: number) => {
  return x1 == x2 && y1 === y2
}

export function findClosestTo<T extends IIJ>(
  objs: T[],
  i: number,
  j: number,
  filter: (c: T) => boolean,
  invalid: T[] = [],
): T | null {
  let closestDistance = 10000000
  let closest: T | null = null

  l.forEach(objs, (c) => {
    let d = distanceSquared(i, j, c.i, c.j)
    if (d < closestDistance) {
      if (filter(c)) {
        if (!l.includes(invalid, c)) {
          closestDistance = d
          closest = c
        }
      }
    }
  })
  return closest
}

export function exists<T extends IIJ>(
  objs: T[],
  filter: (c: T) => boolean,
  invalid: T[] = [],
): T | null {
  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]
    if (filter(c)) {
      if (!l.includes(invalid, c)) {
        return c
      }
    }
  }
  return null
}
